import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { HORM_M } from "../../../../constants";


export default function HormMaleAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={HORM_M}
        title="HORMONAL BALANCE, ENERGY & LIBIDO"
        subtitle="A comprehensive view of the hormonal drivers of male sexual health, energy, and long-term vitality"
        markersTitle=" 149,- incl. VAT"
        markers="Estradiol (E2), Testosterone, Luteinizing Hormone (LH), Follicle-Stimulating Hormone (FSH), Progesterone (P4), Prolactin, Bioavailable Testosterone, SHBG, DHEA-S, Testosterone/E2 ratio"

    />

)
}